// el.call('changeGlobalTheme', 'light' | 'dark' | 'auto') — the framework's
// theme switch, registered ONCE, here. Every theme control calls it through
// el.call: shared's ThemeToggle and account menu, the shell's MeMenu / home
// look / the assistant's set_theme tool, canvas's voice command. The shell and
// the marketplace each used to register their own copy under this name; in a
// catalog that merges them the order picked one.
//
// A static import, not `await import('smbls')`: frank resolves a static
// framework import through the framework package registry, so the serialized
// function works on a published page without a browser import map (pinned by
// marketplace/functions/sharedChangeGlobalTheme.test.js). shared already imports smbls statically
// (setLang.js), so this adds nothing to any bundle.
import { changeGlobalTheme as applyGlobalTheme } from 'smbls'

export function changeGlobalTheme(...args) {
  return applyGlobalTheme(...args)
}
